import { Controller } from "@hotwired/stimulus"

// The co-therapy block of the appointment form: the lead cannot also be the
// second practitioner, the payer buttons carry the two names, and the venue
// part follows the service's default until someone types a value.
export default class extends Controller {
  static targets = ["service", "lead", "co", "fee", "leadName", "coName"]
  static values = { persisted: { type: Boolean, default: false } }

  connect() {
    this.feeTouched = this.persistedValue
    this.sync()
  }

  sync() {
    const leadId = this.hasLeadTarget ? this.leadTarget.value : ""
    if (this.hasCoTarget) {
      Array.from(this.coTarget.options).forEach(option => {
        if (!option.value) return
        option.disabled = option.value === leadId
        option.hidden = option.disabled
      })
      if (this.coTarget.value === leadId) this.coTarget.value = ""
    }
    const nameOf = select => select?.selectedOptions[0]?.textContent?.trim() || "—"
    if (this.hasLeadNameTarget) this.leadNameTarget.textContent = nameOf(this.hasLeadTarget ? this.leadTarget : null)
    if (this.hasCoNameTarget) this.coNameTarget.textContent = nameOf(this.hasCoTarget ? this.coTarget : null)
  }

  serviceChanged() {
    this.sync()
    if (!this.hasFeeTarget || !this.hasServiceTarget || this.feeTouched) return
    const fee = this.serviceTarget.selectedOptions[0]?.dataset.venueFee
    if (fee !== undefined) this.feeTarget.value = fee
  }

  feeInput() {
    this.feeTouched = true
  }
}
